module.exports = __webpack_public_path__ + "static/img/team.9838651.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/team.png
// module id = Y80m
// module chunks = 0